export default __webpack_public_path__ + "static/media/snow.3dbfb7f7.glsl";